import { render } from "./WorkplaceOverview.vue?vue&type=template&id=0aa748f2&scoped=true"
import script from "./WorkplaceOverview.vue?vue&type=script&lang=js"
export * from "./WorkplaceOverview.vue?vue&type=script&lang=js"

import "./WorkplaceOverview.vue?vue&type=style&index=0&id=0aa748f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa748f2"]])

export default __exports__